export function getGtmLabel(value?: string) {
    if (! value) return {};

    return {
        'data-gtm': value
    };
}
